import { render, staticRenderFns } from "./IsESMOnly.vue?vue&type=template&id=a1d79cba&scoped=true&"
import script from "./IsESMOnly.vue?vue&type=script&lang=js&"
export * from "./IsESMOnly.vue?vue&type=script&lang=js&"
import style0 from "./IsESMOnly.vue?vue&type=style&index=0&id=a1d79cba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1d79cba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
